import QuestionAnswer from "@mui/icons-material/QuestionAnswer";
import { Box, Button, Typography } from "@mui/material";
import { ScoutHost } from "generated-graphql/graphql";
import { useFrontChatPresent } from "hooks/useFrontChatPresent";
import { useCallback } from "react";
import { openFrontChatWithAiBotBypass } from "util/openFrontChat";

import { useScoutHostContext } from "./ScoutHostContext";

export function ScoutRepresentativeInline() {
  const frontPresent = useFrontChatPresent();
  const { host, closeScout } = useScoutHostContext();

  const handleActivate = useCallback(() => {
    openFrontChatWithAiBotBypass();
    if (host === ScoutHost.Popover) {
      closeScout?.();
    }
  }, [closeScout, host]);

  if (!frontPresent) {
    return null;
  }

  return (
    <Box sx={{ my: 2 }}>
      <Button
        onClick={handleActivate}
        variant="outlined"
        data-testid="scout-representative-inline"
        startIcon={<QuestionAnswer fontSize="small" />}
        sx={{ textTransform: "none", width: "fit-content", py: 1, px: 8 }}
      >
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          Need an Encamp Representative?
        </Typography>
      </Button>
    </Box>
  );
}
